

export const GET_PURCHASE_LIST = 'GET_PURCHASE_LIST';
export const POST_PURCHASE_SAVE = 'POST_PURCHASE_SAVE';
export const POST_PURCHASE_DELETE = 'POST_PURCHASE_DELETE';
export const GET_PURCHASE_PENDING_ITEMS = 'GET_PURCHASE_PENDING_ITEMS';
export const GET_PURCHASE_ID = 'GET_PURCHASE_ID';
export const PURCHASE_ERROR = 'PURCHASE_ERROR';
